import { ClipFilter, LimitFilter, SlideFilter } from '@apeiron/common'
import * as yup from 'yup'

const limitFilterSchema: yup.SchemaOf<LimitFilter> = yup.object({
  field: yup.string().default(''),
  slot: yup.number().default(0)
})

export const slideFilterSchema: yup.SchemaOf<SlideFilter> = yup
  .object({
    decimalScale: yup.number().default(0),
    image: yup.string().default(''),
    name: yup.string().default(''),
    remark: yup.string().default(''),
    step: yup.number().default(0),
    min: limitFilterSchema,
    max: limitFilterSchema
  })
  .camelCase()
  .noUnknown(true)

export const clipFilterSchema = <T extends unknown>(
  valueSchema: yup.SchemaOf<T>
): yup.SchemaOf<ClipFilter<T>> => {
  return yup
    .object({
      field: yup.string().default(''),
      image: yup.string().default(''),
      name: yup.string().default(''),
      values: yup.array().of(valueSchema).default([])
    })
    .camelCase()
    .noUnknown(true)
}
